import type { CSSProperties } from 'react';
import { UserRound } from 'lucide-react';

/** A member's round picture, or the default icon plate. Decorative: the name always sits beside it. */
export function Avatar({
  url,
  size,
  className = '',
}: {
  url: string | null | undefined;
  size: number;
  className?: string;
}) {
  return (
    <span
      className={('avatar ' + className).trim()}
      style={{ '--avatar-size': size + 'px' } as CSSProperties}
      aria-hidden="true"
    >
      {url ? (
        <img src={url} alt="" width={size} height={size} decoding="async" loading="lazy" />
      ) : (
        <UserRound size={Math.max(12, Math.round(size * 0.44))} />
      )}
    </span>
  );
}
